module.exports = __webpack_public_path__ + "img/monkeyidle.2d3effeb.png";